import React, { useState, useEffect, useCallback } from 'react'; // useCallback hozzáadva
import { Badge, IconButton, Tooltip } from '@mui/material';
import { Notifications } from '@mui/icons-material';
import notificationService from '../../services/notificationService';
import { useAuth } from '../../contexts/AuthContext';

const NotificationBadge = () => {
  const { user } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);

  const loadUnreadCount = useCallback(async () => {
    if (!user) {
      setUnreadCount(0);
      return;
    }
    try {
      const response = await notificationService.getUnreadCount();
      setUnreadCount(response.unreadCount);
    } catch (error) {
      console.error('Olvasatlan értesítések száma hiba:', error);
      setUnreadCount(0);
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      loadUnreadCount();

      const pollIntervalId = notificationService.pollUnreadCount(
        (count) => setUnreadCount(count),
        30000
      );

      return () => {
        if (pollIntervalId) {
          clearInterval(pollIntervalId);
        }
      };
    } else {
      setUnreadCount(0);
    }
  }, [user, loadUnreadCount]);

  if (!user) {
    return null;
  }

  return (
    <Badge badgeContent={unreadCount} color="error" max={99}>
      <Notifications />
    </Badge>
  );
};

export default NotificationBadge;